// Requires `js--modules--Arrows.min.js`


document.querySelectorAll('.js-article-carousel').forEach(carousel => {
  const main = carousel.querySelector('.c-media-carousel--main');
  const thumbs = carousel.querySelector('.js-c-media-carousel--thumbs');
  const mediaCnt = thumbs.children.length;
  const prevArrow = carousel.querySelector('.slick-prev');
  const nextArrow = carousel.querySelector('.slick-next');
  const arrows = new window.APP.Arrows(mediaCnt, prevArrow, nextArrow);

  // Init Swipe
  const swipe = new Swipe(main, {
    speed: window.APP.config.carouselTransitionDur,
    continuous: false,
    callback: (index,) => {
      arrows.update(index);

      // Activate/deactivate thumbs
      thumbs.querySelector(':disabled').removeAttribute('disabled');
      thumbs.querySelector(`#js-thumb-i-${index}`).setAttribute('disabled', '');
    },
  });

  // Add event listeners
  prevArrow.addEventListener('click', () => swipe.prev());
  nextArrow.addEventListener('click', () => swipe.next());
  document.addEventListener('keydown', (evt) => {
    switch (evt.code) {
      case 'ArrowLeft': swipe.prev(); break;
      case 'ArrowRight': swipe.next(); break;
    }
  });
  thumbs.querySelectorAll('button').forEach(button => {
    button.addEventListener('click', () => swipe.slide(button.dataset.thumbI));
  });
});
